import React from "react";
import * as Fa from "react-icons/fa";
import { toast } from "react-toastify";
import { useState } from "react";
import {
    createAPIEndpoint,
    Endpoint,
} from "../../../Services/stockreport/StockReport";
import storage from "../../../Services/Storage";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import Loader from "../../../Components/Loader";
import { GetDateFormat } from "../../../Services/GlobalFunc/DateFormat";
import { downloadExcel } from "../../../Services/GlobalFunc/downloadExcel";
import Axios from "../../../api/Axios";
const StockInHand = () => {
    const [productCode, setProductCode] = useState("");
    // const[showAll,setShowAll]=useState(false);
    const [errorLable, setErrorLabel] = useState(false);
    const [submitBtn, setSubmitBtn] = useState(false);
    const [allStockData, setAllStockData] = useState([]);
    const [loadingStock, setLoadingStock] = useState(false);
    const [loadingExcel, setLoadingExcel] = useState(false);
    const [loadingstk, setLoadingstk] = useState(false);


    const auth = storage.getLocal("user");
    const handleChange = (data) => {
        if (data == "") {
            setErrorLabel(true);
            setSubmitBtn(false);
        } else {
            setErrorLabel(false);
            setSubmitBtn(true);
        }
        setProductCode(data);
    };
    const handleGetStockData = () => {
        setAllStockData([]);
        setLoadingStock(true);
        createAPIEndpoint()
            .get(
                `${Endpoint.GetStockData}?CICode=${auth.CICode}&Prod_Code=${productCode}&Checked=Y&strCompId=${auth.CompId}`
            )
            .then((val) => {
                setAllStockData(val.data.StockData);
                setLoadingStock(false);
            })
            .catch((err) => {
                setLoadingStock(false);
                toast.error(err.response.data.Message, {
                    position: toast.POSITION.TOP_CENTER,
                    pauseOnFocusLoss: false,
                    closeButton: false,
                    autoClose: 2000,
                });
                setAllStockData("");
            });
        setProductCode("");
        // setShowAll(false);
        setSubmitBtn(false);
    };

    const allocateStock = async () => {
        try {
            setLoadingstk(true);
            let allocateURL = "StockAdjustment/AllocateStock";
            let allocatepayload = {
                UserId: auth.UserId,
                CompId: auth.CompId,
            };
            let dataresponse = await Axios.post(
                allocateURL,
                JSON.stringify(allocatepayload),
                {
                    headers: { "Content-Type": "application/json" },
                }
            );
            toast.success(dataresponse.data.Message, {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 2000,
            });
        } catch (error) {
            toast.error(error.response.data.Message, {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 2000,
            });
        } finally {
            setLoadingstk(false);
        }
    };

    const handleExportExcel = () => {
        setLoadingExcel(true);
        createAPIEndpoint()
            .get(
                `${Endpoint.GetStockDataExcel}?CICode=${auth.CICode}&Checked=Y&CompId=${auth.CompId}`
            )
            .then((val) => {
                downloadExcel(val.data.StockData, `StockData${GetDateFormat()}.xlsx`);
                setLoadingExcel(false);
            })
            .catch((error) => {
                console.log(error);
                setLoadingExcel(false);
            });
    };
    return (
        <div className="col-12 pt-0 pb-4">
            {/* Header with button aligned */}
            <div className="d-flex justify-content-between align-items-center mb-3">
                <h3 className="mb-0">Stock In Hand</h3>
                <button
                    type="submit"
                    className="btn btn-primary"
                    onClick={allocateStock}
                    disabled={loadingstk}
                >
                    {loadingstk ? "Loading..." : "De-Allocate Stock"}
                    {loadingstk && (
                        <span
                            className="spinner-border spinner-border-sm ms-2"
                            role="status"
                            aria-hidden="true"
                        ></span>
                    )}
                </button>
            </div>

            {/* Product Code Input Section */}
            <section className="sales-box">
                <form>
                    <div className="row d-flex justify-content-end align-items-end">
                        <div className="col-lg-6 col-md-6 col-sm-12">
                            <label className="form-label">
            Product Code{" "}
                                <span className="smallLabel">
              (**Enter Product Code to get Stock Data**)
                                </span>
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                value={productCode}
                                onChange={(e) => handleChange(e.target.value)}
                            />
                            {errorLable && (
                                <p style={{ color: "red" }}>Enter product code</p>
                            )}
                        </div>

                        {/* Buttons: Get Stock + Export */}
                        <div className="col-lg-6 col-md-6 col-sm-12">
                            <div className="text-end">
                                <button
                                    type="button"
                                    className="btn btn-outline-primary me-3"
                                    disabled={!submitBtn}
                                    onClick={handleGetStockData}
                                >
                                    {loadingStock ? "Loading..." : "Get Stock Data"}
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={handleExportExcel}
                                    disabled={loadingExcel}
                                >
                                    {loadingExcel ? "Loading..." : "Export All"}{" "}
                                    <Fa.FaFileExport className="ms-2" />
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            </section>

            {/* Loader or Stock Data Table */}
            {loadingStock ? (
                <Loader />
            ) : (
                <div className="col-lg-12 col-md-12 col-sm-12">
                    <h3>Records</h3>
                    <div className="DataTable pt-1 pb-4">
                        <DataTable
                            value={allStockData}
                            paginator
                            rows={10}
                            rowsPerPageOptions={[5, 10, 25, 50]}
                            scrollHeight="80vh"
                            scrollable
                            stripedRows
                            tableStyle={{ minWidth: "100rem" }}
                        >
                            <Column field="STK_PROD_ID" header="Product Code" />
                            <Column field="PROD_SMALL_DESC" header="Product Description" />
                            <Column field="LOCATION_DESC" header="Location" />
                            <Column field="STK_TYPE_DESC" header="Stock Type" />
                            <Column field="WH_DESC" header="Warehouse" />
                            <Column field="PROD_BATCH_NO" header="Lot Number" />
                            <Column field="PRODUCT_MRP" header="MRP(₹)" />
                            <Column field="PACK_UOM_DESC" header="UOM" />
                            <Column field="QTY_PACK" header="Quantity(Pack)" />
                            <Column field="QTY_LTR" header="Quantity(EA/Ltrs/Kg)" />
                            <Column
                                field="STK_ALLOCATED_QTY_PACK"
                                header="Allocated Stock(Pack)"
                            />
                        </DataTable>
                    </div>
                </div>
            )}
        </div>

    );
};

export default StockInHand;
